import React from "react"
import ActionButton from "./actionbutton.component"
import { EditDesignButtonProps } from "../types/button"
import { Redirect } from "react-router"
import Icon from "../icon/icon.component"
import { FormattedMessage } from "react-intl"

export const EditDesignButton = (props: EditDesignButtonProps) => {
    const [redirect, setRedirect] = React.useState<React.ReactNode>(null)
    
    const onRedirect = () => {
        const uri = props.editMode ? "?em=1" : ""
        setRedirect(<Redirect to={`/proposals/${props.proposalHash}/preview${uri}`}/>)
    }

    return (
        <>
            {redirect}
            <ActionButton className="btn btn-outline-primary mr-2"
                onClick={onRedirect}>
                <Icon value={"pencil-ruler"} className={"mr-1"}/>
                <FormattedMessage
                    id="common.placeholder.edit_design"
                    defaultMessage="Edit design"
                />
            </ActionButton>
        </>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/EditDesignButton.tsx